// extracted by mini-css-extract-plugin
export default {"base":"vp_D9jVM","preview":"vp_K9j9Z","segment":"vp_2CiBK","selected":"vp_AJlVX","colon":"vp_cdwyS","picker":"vp_MLpyh"};